module.exports = __webpack_public_path__ + "img/img-13.764be7ba.png";